import { render, staticRenderFns } from "./Porque.vue?vue&type=template&id=6eff561c&scoped=true&"
import script from "./Porque.vue?vue&type=script&lang=js&"
export * from "./Porque.vue?vue&type=script&lang=js&"
import style0 from "./Porque.vue?vue&type=style&index=0&id=6eff561c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eff561c",
  null
  
)

export default component.exports